import { useEffect, useRef } from 'react';

interface ClickAwayListenerProps {
  children: React.ReactNode;
  onClickAway: (event: MouseEvent) => void;
}

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({ children, onClickAway }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // alert('You clicked outside of me!');
        onClickAway(event);
      }
    }
    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref]);

  return (
    <div ref={ref} style={{ width: '100%' }}>
      {children}
    </div>
  );
};

export default ClickAwayListener;
